module.exports = "<p>\n  tab-cv works!\n</p>\n"